/**
 * Runtime OIDC settings for the identity-broker (ZITADEL) login path.
 *
 * These arrive in `config.json` rather than at build time, deliberately: a
 * build-time toggle cannot be flipped per deployment, which is the mistake to
 * avoid when the same image is deployed to several environments.
 *
 * When both values are present the broker path is used; otherwise the app keeps
 * its existing Azure Entra / MSAL behaviour unchanged.
 */

export type OidcSettings = {
    /** Issuer URL, e.g. https://sso.mvision.ai (no realm path for ZITADEL). */
    authority: string;
    /** Client id of the User Agent application registered at the broker. */
    clientId: string;
};

let settings: OidcSettings | undefined = undefined;

/** Records the OIDC settings parsed from config.json. Called once at startup. */
export const setOidcSettings = (value: OidcSettings | undefined) => {
    settings = value;
};

/** The configured OIDC settings, or undefined when the broker path is off. */
export const getOidcSettings = (): OidcSettings | undefined => settings;

/** True when the app should authenticate against the broker instead of Entra. */
export const isOidcEnabled = (): boolean => settings !== undefined;
